// extracted by mini-css-extract-plugin
export default {"component":"State_component__vl5ZU","icon":"State_icon__URMp4","content":"State_content__pHsGh"};